// auth
import ContentFormatXZ from "../content/webz/content-format-xz";

import AuthSessionXModule from "../content/auth/auth-session-x";

export default function AuthSessionX () {

  return(
    <>
      <ContentFormatXZ 
        head = 'Accounts'
        home = {`/`}
        link = {`/`}
        form = 'mini'
        data = {
          <>
            <AuthSessionXModule/>
          </>
        } 
      />
    </>
  )
}